import React, {
  createContext,
  useContext,
  useMemo,
} from "react";

const AdminRuntimeContext = createContext(null);

export function AdminRuntimeContextProvider({
  children,
  value,
}) {
  return (
    <AdminRuntimeContext.Provider value={value}>
      {children}
    </AdminRuntimeContext.Provider>
  );
}

export function useOptionalAdminRuntime() {
  return useContext(AdminRuntimeContext);
}

export function useAdminRuntime() {
  const runtime = useOptionalAdminRuntime();

  if (!runtime) {
    throw new Error(
      "useAdminRuntime must be used within AdminRuntimeProvider"
    );
  }

  return runtime;
}

export function usePanelRuntime() {
  const runtime = useAdminRuntime();

  return useMemo(
    () => ({
      panelMode: runtime.panelMode,
      panelContext: runtime.panelContext,
      panelKey: runtime.panelKey,
      panelConfig: runtime.panelConfig,
      isFullscreen: runtime.isFullscreen,
      hasRegisteredPanel: runtime.hasRegisteredPanel,
      openPanel: runtime.openPanel,
      closePanel: runtime.closePanel,
      toggleFullscreen: runtime.toggleFullscreen,
    }),
    [
      runtime.panelMode,
      runtime.panelContext,
      runtime.panelKey,
      runtime.panelConfig,
      runtime.isFullscreen,
      runtime.hasRegisteredPanel,
      runtime.openPanel,
      runtime.closePanel,
      runtime.toggleFullscreen,
    ]
  );
}

export default AdminRuntimeContext;
